
export const nftmarketaddress = "0x170fe306D66dca2907a549754a47bFde975Fe64D"
export const nftaddress = "0x933fAc08bd6d8C978AB5a919Ab8C5298f1b1C80F"
  